import {
  CollaborationSharing,
  CollectionCollaborator,
  CollectionCollaboratorRef,
  CollectionInvitation,
  CollectionRef,
  CollectionSummary,
} from "@/types/collection"
import { UserRef } from "@/types/user"

import { BaseApi } from "@/lib/base-api"

export class CollectionCollaborationApi extends BaseApi {
  async fetchCollaborators(collectionRef: CollectionRef) {
    return await this.get<{
      saved_collection: {
        collaborators: CollectionCollaborator[]
        stats: {
          total_count: number
          pending_count: number
          accepted_count: number
        }
      }
    }>(`/api/saved_collections/${collectionRef}/collaborators`)
  }

  async addCollaborator(collectionRef: CollectionRef, userIdentifier: string) {
    return await this.post<{
      saved_collection: {
        collaborator: CollectionCollaborator
      }
    }>(`/api/saved_collections/${collectionRef}/add_collaborator`, {
      user_identifier: userIdentifier,
    })
  }

  async removeCollaborator(collectionRef: CollectionRef, userRef: UserRef) {
    return await this.delete<void>(
      `/api/saved_collections/${collectionRef}/collaborators/${userRef}`
    )
  }

  async resendInvitation(
    collectionRef: CollectionRef,
    collaboratorRef: CollectionCollaboratorRef
  ) {
    return await this.patch<{
      saved_collection: {
        collaborator: CollectionCollaborator
      }
    }>(
      `/api/saved_collections/${collectionRef}/collaborators/${collaboratorRef}/resend`,
      {}
    )
  }

  async fetchSharing(collectionRef: CollectionRef) {
    return await this.get<{
      saved_collection: {
        sharing: CollaborationSharing
      }
    }>(`/api/saved_collections/${collectionRef}/sharing`)
  }

  async updateCollaborationLinkStatus(
    collectionRef: CollectionRef,
    disabled: boolean
  ) {
    return await this.patch<{
      saved_collection: {
        sharing: CollaborationSharing
      }
    }>(
      `/api/saved_collections/${collectionRef}/update_collaboration_link_status`,
      {
        disabled,
      }
    )
  }

  async declineInvitation(ref: CollectionCollaboratorRef) {
    return await this.delete<void>(`/api/collection_invitations/${ref}/decline`)
  }

  async acceptInvitationViaToken(token: string) {
    return await this.post<{
      saved_collection: {
        collection: CollectionSummary
        collaborator: CollectionCollaborator
      }
    }>(`/api/collection_join/${token}`)
  }

  async fetchInvitation(token: string): Promise<CollectionInvitation> {
    const response = await this.get<{
      saved_collection: {
        invitation: CollectionInvitation
      }
    }>(`/api/collection_invitations/${token}`)

    return response.saved_collection.invitation
  }
}
